<!-- Dialog: CANCEL TARDE CONFIRM  -->
<p-dialog
  #dialog
  [(visible)]="data.dialogData.show"
  [width]="data.dialogData.width"
  appendTo="body"
  [resizable]="false"
  [closable]="true"
  [draggableDialog]="dialog"
  [modal]="true"
  styleClass="bfx-dialog-normal"
  (onHide)="closeDialog()"
>
  <p-header> {{title}} </p-header>
  <div>
    <p *ngIf="messages.length==1">{{messages[0]}}</p>
    <p *ngIf="subMessage!=null">{{subMessage}}</p>
  </div>

  <p-footer fxLayout="row" fxLayoutGap="4px" fxLayoutAlign="end center">
    <button
      pButton
      type="button"
      class="bfx-button-secondary-subtle"
      (click)="closeDialog()"
      label="{{noLabel}}"
    ></button>
    <button
      pButton
      type="button"
      class="bfx-button-primary"
      (click)="actionReconnect()"
      label="{{yesLabel}}"
    ></button>
  </p-footer>
</p-dialog>
